import Model, { encoders, ID, MODEL_LEVEL } from 'src/models/model'
import Order, { getAncestorOrder } from 'src/models/order/Order'
import TicketType from 'src/models/showing/TicketType'
import User from 'src/models/user/User'

export default class ActivityTicket extends Model {
  static name = 'ActivityTicket'

  static versioned = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Customer]

  static define () {
    this.fields = {
      id: {
        type: ID,
        sortable: true
      },
      order: {
        type: Order,
        reference: true,
        output: true,
        computed () {
          return getAncestorOrder(this) || this.data?.order
        }
      },
      activityBookingId: {
        type: ID,
        sortable: true
      },
      state: {
        type: String,
        output: true,
        default: 'draft',
        sortable: true
      },
      ticketType: {
        type: TicketType,
        reference: true,
        default: null,
        encode: encoders.hasOne
      },
      user: {
        type: User,
        reference: true,
        default: null,
        encode: encoders.hasOne
      },
      price: {
        type: Number,
        output: true,
        default: null,
        computed () {
          if (this.state !== 'draft') return this.data.price

          return this.finalTicketType.price
        }
      }
    }

    this.computed = {
      activityBooking () {
        return _.find(this.order?.activityBookings.data, activityBooking => activityBooking.id === this.activityBookingId)
      },
      finalTicketType () {
        const priceCardItem = _.find(
          this.activityBooking?.activitySession?.priceCard?.priceCardItems?.data || [],
          priceCardItem => priceCardItem.ticketType?.id === this.ticketType.id
        )

        if (priceCardItem && priceCardItem.hasCustomPrice) {
          // CLONE THE TICKET TYPE AND OVERRIDE THE PRICE
          const clone = priceCardItem.ticketType.clone()
          clone.price = priceCardItem.customPrice

          const factor = this.activityBooking?.activityUnitQuantity || 1
          const prices = {
            price: clone.factorPrice(factor)
          }
          clone.destroy()
          return prices
        }

        const factor = this.activityBooking?.activityUnitQuantity || 1
        return { price: this.ticketType.factorPrice(factor) }
      },
      activityLabel () {
        if (_.isNil(this.activityBooking)) return null

        const partsOfLabel = []

        if (this.activityBooking.activity.name) {
          partsOfLabel.push(this.activityBooking.activity.name)
        }

        if (this.activityBooking.activityUnitQuantityDescription) {
          partsOfLabel.push(this.activityBooking.activityUnitQuantityDescription)
        }

        if (this.activityBooking.activitySpaceDescription) {
          partsOfLabel.push(this.activityBooking.activitySpaceDescription)
        }

        partsOfLabel.push(this.activityBooking.formattedTime(true, false) || this.i18n.t('pages.activitySelectTickets.messages.pleaseSelectDateAndTime'))

        return partsOfLabel.join(' - ')
      },
      activityFormattedTime () {
        if (_.isNil(this.activityBooking)) return null
        return this.activityBooking.formattedTime(true, false) || this.i18n.t('pages.activitySelectTickets.messages.pleaseSelectDateAndTime')
      }
    }

    this.paginate = true
  }
}
